import { List, Seq } from 'immutable';
import { createSelector } from 'reselect';
import { getEvents } from '../../modules/events/selectors';

export const getEventsDay = state => state.getIn(['liveScores', 'eventsDay']);
export const getCurrentEventId = state => state.getIn(['liveScores', 'currentEventId']);
export const getCompetitionVisibility = (
  state => state.getIn(['liveScores', 'competitionVisibility'])
);

export const getVisibleCompetitions = createSelector(
  getCompetitionVisibility,
  ids => ids.filter(visible => visible).keySeq()
);

export const getLiveEvents = createSelector(
  getEvents,
  getVisibleCompetitions,
  getEventsDay,
  getCurrentEventId,
  (events, competitions, day, eventId) => {
    if (eventId) {
      return [{
        sport: 'football',
        eventId,
        timePrecision: 60,
        trackDetails: true
      }];
    }
    return new Seq(events)
      .filter(event => competitions.includes(event.competitionId))
      .filter(event => event.eventInPlay || event.eventIsFinished || day < 0)
      .map(event => ({
        sport: 'football',
        eventId: event.eventId,
        timePrecision: 60
      }))
      .toArray();
  }
);

export const getPDSTopicParams = createSelector(
  getEvents,
  getEventsDay,
  getCurrentEventId,
  (events, day, eventId) => {
    if (eventId) {
      return new List([{ event: eventId }]);
    }
    if (day < 0) {
      return new List();
    }
    return events.map(event => ({ event: event.eventId })).toList();
  }
);
